/**
 * Authentication configuration for AWS Amplify
 */

// Just get the types right to pass build
export const authConfig = {
  Cognito: {
    userPoolId: process.env.REACT_APP_AWS_USER_POOL_ID || 'us-east-1_U5eCxGxar',
    userPoolClientId: process.env.REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID || '2l2pq6hdna2vl5uj31ogbfm5ej',
    loginWith: {
      email: true,
      username: false
    }
  }
};